/*
 * Viretta v2 mega menu (round 79 from the canvas, built on BUILD 10 Oct – round 81). Loaded with defer by sections/header.liquid.
 * Opening / closing the desktop panels is Impact's mega-menu-disclosure; this file only
 *  · switches the group on the right when a group on the left is hovered or focused (back to the first one on leave)
 *  · moves the mobile drawer between level 1 (the seven items) and level 2 (the groups of one item)
 * Delegated on document, so it survives theme-editor re-renders of the header.
 */
(() => {
  if (window.v2MegaInit) return;
  window.v2MegaInit = true;

  const setGroup = (panel, index) => {
    panel.querySelectorAll('[data-v2m-g]').forEach((g) => g.classList.toggle('is-on', g.dataset.v2mG === String(index)));
    panel.querySelectorAll('[data-v2m-gr]').forEach((gr) => gr.classList.toggle('is-on', gr.dataset.v2mGr === String(index)));
  };

  const onEnter = (event) => {
    const g = event.target.closest?.('[data-v2m-g]');
    if (!g || g.classList.contains('is-on')) return;
    setGroup(g.closest('[data-v2m-panel]'), g.dataset.v2mG);
  };
  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);

  /* white header while a menu panel or the search is open (owner 10 Oct: on transparent-header pages it sometimes stayed
     dark – the header's own scroll handler drops »is-filled« near the top of the page, e.g. a wheel scroll over an open panel) */
  const panelOpen = () => document.documentElement.classList.contains('v2s-is-open') || !!document.querySelector('.v2m-item[open]');
  const syncHeader = () => {
    const header = document.querySelector('store-header');
    if (!header) return;
    if (panelOpen()) header.classList.add('is-filled');
    else header.classList.toggle('is-filled', window.scrollY > 50);
  };
  // watch the html class (search open / closed) and the header's own class (any script that drops »is-filled«)
  const keep = new MutationObserver(() => { if (panelOpen() && !document.querySelector('store-header')?.classList.contains('is-filled')) syncHeader(); });
  const watch = () => {
    keep.disconnect();
    keep.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    const header = document.querySelector('store-header');
    if (header) keep.observe(header, { attributes: true, attributeFilter: ['class'] });
  };
  watch();
  document.addEventListener('shopify:section:load', watch);

  // a closed panel opens again on its first group; the header follows the panels
  document.addEventListener('toggle', (event) => {
    const d = event.target;
    if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('v2m-item')) return;
    requestAnimationFrame(syncHeader);
    if (d.open) return;
    const panel = d.querySelector('[data-v2m-panel]');
    if (panel) setGroup(panel, 0);
  }, true);

  /* mobile levels */
  document.addEventListener('click', (event) => {
    const open = event.target.closest?.('[data-v2mm-open]');
    const back = event.target.closest?.('[data-v2mm-back]');
    if (!open && !back) return;
    const root = event.target.closest('[data-v2mm]');
    if (!root) return;
    event.preventDefault();
    root.querySelectorAll('[data-v2mm-panel]').forEach((p) => { p.hidden = !open || p.dataset.v2mmPanel !== open.dataset.v2mmOpen; });
    root.classList.toggle('is-l2', !!open);
    root.scrollTop = 0;   // the menu scrolls inside the drawer (v2-mega.css)
    if (back) root.querySelector(`[data-v2mm-open="${back.closest('[data-v2mm-panel]')?.dataset.v2mmPanel || ''}"]`)?.focus();
  });

  // closing the drawer brings the menu back to level 1
  document.addEventListener('dialog:after-hide', (event) => {
    const root = event.target.querySelector?.('[data-v2mm]');
    if (!root) return;
    root.classList.remove('is-l2');
    root.querySelectorAll('[data-v2mm-panel]').forEach((p) => { p.hidden = true; });
  });
})();
